import { ReactNode } from 'react'
import LanguageSelector from './LanguageSelector'
import { AuthFeedbackButton } from '../feedback/AuthFeedbackButton'
import PublicPageLayout from './PublicPageLayout'

interface Props {
  children: ReactNode
}

export default function AuthLayout({ children }: Props) {
  return (
    <PublicPageLayout>
      <div className="relative">
        <div className="absolute top-4 right-4 z-10">
          <LanguageSelector />
        </div>
        {children}
        <AuthFeedbackButton />
      </div>
    </PublicPageLayout>
  )
}
